import {Show} from 'react-admin';

const ShowMod = props => {
    return (<Show {...props} />);
};

export default ShowMod;